import React, {Component} from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";
// import List from "../CompanyList/List";
// import MenuRecord from "../Record/MenuRecord";
// import DateTime from "../Record/DateTime/DateTime";
// import Service from "../Record/Service/Service";
// import Staff from "../Record/Staff/Staff";
// import Menu from "../Menu";
// import Order from "../Record/Order/Order";
import GlobalVariable from "../../GlobalVariable";
import api from "../../api";
import axios from "axios";
import Menu from "../Menu";
import Preloader from "../Preloader";
import PageHeader from "../PageHeader";
import './MyRecord.scss';
import {getRecordComment} from './recordComment';


export class MyRecord extends Component <any, any> {
    constructor(props: any) {
        super(props);window.scrollTo(0, 0);
        this.state = {
            staff: [],
            service: [],
            dateTime: [],
            activeBlock: '',
            activeDate: null,
            activeCompany: [],
            recordsPrev: [],
            recordsNext: [],
            recordsNext2: [],
            recordsPrev2: [],
            recordsNextLoaded: false,
            recordsPrevLoaded: false,
            recordsNextError: '',
            recordsPrevError: '',
            isLoad: false,
            isLoadCalendar: false,
            calendarError: '',
            auth: true,
            activeRecord: '',
            balls: 0,
            calendar: '',
            nameMonth: '',
            activeMonth: '',
            isArchive: false,
            statusUpdating: null,
            clientCardOpen: false,
            clientCard: null,
            clientFormula: '',
            clientCardSaving: false,
            clientCardError: '',
            clientSearchQuery: '',
            clientSearchResults: [],
            clientSearchLoading: false,
            clientSearchError: '',
            recordListMode: 'mine',
            availableRecords: [],
            availableRecordsCompanyId: 0,
            availableRecordsLoading: false,
            availableRecordsError: '',
            claimingRecordId: null,
            releasingRecordId: null,
            deletingRecordId: null,
            moveRecord: null,
            moveDateTime: '',
            movingRecordId: null,
            recordActionError: '',
            moveRecordError: ''
        };


    }


    buildCurrentDateTime() {
        const date = new Date();
        const leadingZero = (token) => ("0" + token).slice(-2);

        const year = date.getFullYear();
        const month = leadingZero(date.getMonth() + 1);
        const day = leadingZero(date.getDate());
        const hours = leadingZero(date.getHours());
        const minutes = leadingZero(date.getMinutes());

        return `${year}-${month}-${day} ${hours}:${minutes}`;
    }

    loadFutureRecords() {
        this.setState({
            isLoad: false,
            recordsNextLoaded: false,
            recordsNextError: '',
        });

        const urlAPI3 = GlobalVariable.host() + '/widget/staff/v1/profile/my-record/next';
        const data3 = {
            dateTime: this.buildCurrentDateTime(),
            limit: 100,
        };

        api({
            url: urlAPI3,
            headers: {'Content-Type': 'application/json'},
            method: "post",
            data: data3,
            withCredentials: true,
        })
            .then(result => { // then print response status
                this.setState({
                    recordsNext2: Array.isArray(result.data) ? result.data : [],
                    recordsNextLoaded: true,
                    isLoad: true,
                    auth: true
                })
            }).catch(error => {
            this.setState({
                recordsNext2: [],
                recordsNextLoaded: true,
                recordsNextError: 'Не удалось загрузить записи. Проверьте подключение и попробуйте обновить страницу.',
                isLoad: true,
            })
        })
    }

    loadCalendar() {
        const data4 = {};

        const urlAPI1 = GlobalVariable.host() + '/widget/staff/v1/profile/calendar';
        api({

            url: urlAPI1,
            headers: {'Content-Type': 'application/json'},
            withCredentials: true,
            method: "POST",
            data: data4,
            // receive two    parameter endpoint url ,form data
        })
            .then(result => { // then print response status
                // console.log(result.data)
                this.setState(
                    {
                        isLoadCalendar: true,
                        calendar: result.data.calendar,
                        currentDate: result.data.currentDate,
                        activeDate: result.data.currentDate,
                        nameMonth: result.data.nameMonth,
                        activeMonth: result.data.activeMonth,
                        calendarError: '',
                    });


            }).catch(error => {
            this.setState({
                isLoadCalendar: true,
                calendar: [],
                calendarError: 'Не удалось загрузить календарь',
            })
        })
    }

    componentDidMount() {
        this.loadFutureRecords();
        this.loadCalendar();
        this.loadAvailableRecords();
    }

    getActiveCompanyParams() {
        if (this.state.availableRecordsCompanyId > 0) {
            return {companyId: this.state.availableRecordsCompanyId};
        }
        try {
            // The legacy home stores a customer's booking salon in companyActive.
            // Only the Staff bootstrap identifies the master's workplace.
            const company = JSON.parse(sessionStorage.getItem('staffCompanyActive') || '{}');
            const companyId = Number(company && (company.id || company.companyId));

            return companyId > 0 ? {companyId} : undefined;
        } catch {
            return undefined;
        }
    }

    loadAvailableRecords(clearError = true) {
        this.setState({availableRecordsLoading: true, ...(clearError ? {availableRecordsError: ''} : {})});
        const params = this.getActiveCompanyParams();
        const request = {
            url: GlobalVariable.host() + '/widget/staff/v2/records/available',
            headers: {'Content-Type': 'application/json'},
            withCredentials: true,
            method: 'get' as const,
            params,
        };
        api(request).catch(error => {
            if (params && error?.response?.status === 404
                && error?.response?.data?.error === 'staff_profile_not_found') {
                // An outdated workplace must be reselected by the authenticated API.
                return api({...request, params: undefined});
            }
            throw error;
        }).then(result => {
            this.setState({
                availableRecords: Array.isArray(result.data && result.data.items) ? result.data.items : [],
                availableRecordsCompanyId: Number(result.data?.company?.id) || 0,
                availableRecordsLoading: false,
            });
        }).catch(() => {
            this.setState({
                availableRecords: [],
                availableRecordsLoading: false,
                availableRecordsError: 'Не удалось загрузить доступные записи.',
            });
        });
    }

    claimAvailableRecord(idRecord) {
        if (this.state.claimingRecordId) {
            return;
        }
        this.setState({claimingRecordId: idRecord, availableRecordsError: ''});
        api({
            url: GlobalVariable.host() + '/widget/staff/v2/records/' + idRecord + '/claim',
            headers: {'Content-Type': 'application/json'},
            withCredentials: true,
            method: 'post',
            data: {},
            params: this.getActiveCompanyParams(),
        }).then(() => {
            this.setState({claimingRecordId: null, recordListMode: 'mine'});
            this.loadAvailableRecords();
            this.loadFutureRecords();
        }).catch(error => {
            const code = error && error.response && error.response.data && error.response.data.error;
            this.setState({
                claimingRecordId: null,
                availableRecordsError: code === 'POOL_ALREADY_ASSIGNED'
                    ? 'Эту запись уже забрал другой мастер.'
                    : 'Не удалось забрать запись. Возможно, время уже занято.',
            });
            this.loadAvailableRecords(false);
        });
    }

    releasePoolRecord(idRecord) {
        if (this.state.releasingRecordId) {
            return;
        }
        this.setState({releasingRecordId: idRecord, recordsNextError: ''});
        api({
            url: GlobalVariable.host() + '/widget/staff/v2/records/' + idRecord + '/release',
            headers: {'Content-Type': 'application/json'},
            withCredentials: true,
            method: 'post',
            data: {},
            params: this.getActiveCompanyParams(),
        }).then(() => {
            this.setState({releasingRecordId: null, recordListMode: 'available'});
            this.loadFutureRecords();
            this.loadAvailableRecords();
        }).catch(error => {
            const code = error && error.response && error.response.data && error.response.data.error;
            this.setState({
                releasingRecordId: null,
                recordsNextError: code === 'POOL_RELEASE_TOO_LATE'
                    ? 'Вернуть запись можно не позднее чем за 30 минут до начала.'
                    : 'Не удалось вернуть запись в общий пул.',
            });
        });
    }
    activeDate(date) {

        if (date != null) {
            this.setState({activeDate: date});
            this.changeIsArchive(date)
            // this.setState({time: []});

        }


    }
    calendarChange(status) {

        let urlAPI1 = GlobalVariable.host() + '/widget/staff/v1/profile/calendar';

        const data = {

            status: status,
            currentDate: this.state.activeDate,
            activeMonth: this.state.activeMonth

        };


        api({

            url: urlAPI1,
            headers: {'Content-Type': 'application/json'},
            withCredentials: true,
            method: "POST",
            data: data,
            // receive two    parameter endpoint url ,form data
        })
            .then(result => { // then print response status
                this.setState(
                    {
                        calendar: result.data.calendar,
                        currentDate: result.data.currentDate,
                        activeDate: result.data.currentDate,
                        nameMonth: result.data.nameMonth,
                        activeMonth: result.data.activeMonth

                    });


            }).catch(error => {
            this.setState({
                isLoadCalendar: true,
                calendar: [],
                calendarError: 'Не удалось загрузить календарь',
            })
        })
    }
    renderCalendar() {
        const {calendar, activeDate} = this.state;
        if (!this.state.isLoadCalendar) {
            return (<div style={{textAlign: 'center'}}> Загружаем данные! Ожидайте</div>
            )
        }
        if (this.state.calendarError) {
            return (
                <div className='txt-middle text-center mt-3 mb-3'>
                    {this.state.calendarError}
                </div>
            )
        }
        if (calendar.length > 0) {
            return (
                <div className={'ml-3 mr-3 calendar justify-content-between'}>
                    <div style={{justifyContent: 'space-between'}} className={'d-flex'}>
                        <div><h5>{this.state.nameMonth}</h5></div>
                        <div></div>

                        <div className={'d-flex'}>
                            <div style={{cursor: 'pointer'}} onClick={() => this.calendarChange('-1')}><img
                                className="mr-3" src="/img/arrowLeft.png"/></div>
                            <div style={{cursor: 'pointer'}} onClick={() => this.calendarChange('+1')}><img
                                className="mr-3" src="/img/arrowRight.png"/></div>
                        </div>
                    </div>
                    <div className={'d-flex'}>
                        <div className={'day'}>Пн</div>
                        <div className={'day'}>Вт</div>
                        <div className={'day'}>Ср</div>
                        <div className={'day'}>Чт</div>
                        <div className={'day'}>Пт</div>
                        <div className={'day'}>Сб</div>
                        <div className={'day'}>Вс</div>
                    </div>
                    <div style={{flexDirection: 'column'}} className={'d-flex'}>
                        {calendar.map((weeks) => (
                            <div className={'weeks'}>
                                {
                                    weeks.map((day) => (
                                        <div onClick={() => this.activeDate(day.date)} style={{cursor: "pointer"}}
                                             className={'day-num'}>
                                            {
                                                activeDate == day.date ?
                                                    <div className={'active'}>{day.day}</div> : <div
                                                        style={day.status ? {color: 'red'} : {color: 'black'}}> {day.day}</div>
                                            }
                                        </div>
                                    ))
                                }
                            </div>
                        ))}
                    </div>

                </div>
            )
        }

    }
    changeRecordStatus(idRecord, status) {
        if (!idRecord || this.state.statusUpdating) {
            return;
        }
        if (status === 'canceled' && !window.confirm('Отменить запись?')) {
            return;
        }

        this.setState({statusUpdating: idRecord});
        api({
            url: GlobalVariable.host() + '/widget/staff/v2/records/' + idRecord + '/status',
            headers: {'Content-Type': 'application/json'},
            withCredentials: true,
            method: 'POST',
            data: {status},
        }).then((result) => {
            const next = (this.state.recordsNext2 || []).map((record) => {
                if (record.id === idRecord) {
                    return {
                        ...record,
                        status: result.data.status,
                        statusLabel: result.data.statusLabel || this.statusLabel(result.data.status),
                    };
                }
                return record;
            });
            this.setState({recordsNext2: next, statusUpdating: null});
        }).catch(() => {
            this.setState({statusUpdating: null});
            alert('Не удалось изменить статус записи');
        });
    }

    recordActionErrorMessage(error, fallback) {
        const response = error && error.response;
        const data = response && response.data;
        const code = data && (data.code || data.error || data.message);

        if ((response && response.status === 403) || code === 'record_forbidden') {
            return 'У вас нет права на это действие с записью.';
        }

        const messages: {[key: string]: string} = {
            RECORD_LOCKED: 'Запись уже связана с оплатой или бонусами и не может быть изменена.',
            INVALID_DATE_TIME: 'Укажите корректные дату и время.',
            STAFF_SCHEDULE_UNAVAILABLE: 'На выбранное время у вас нет рабочей смены.',
            SLOT_UNAVAILABLE: 'Выбранное время уже занято.',
            record_not_found: 'Запись не найдена. Обновите список.',
        };

        return messages[code] || fallback;
    }

    recordDateTimeLocalValue(record) {
        if (!record) {
            return '';
        }

        const dateTime = String(record.dateTime || '').trim();
        if (dateTime) {
            return dateTime.replace(' ', 'T').slice(0, 16);
        }

        const date = String(record.date || '').trim();
        const time = String(record.time || '').trim().slice(0, 5);
        const match = date.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
        if (match && time) {
            return `${match[3]}-${match[2]}-${match[1]}T${time}`;
        }

        if (/^\d{4}-\d{2}-\d{2}$/.test(date) && time) {
            return `${date}T${time}`;
        }

        return '';
    }

    openMoveRecord(record) {
        if (!record || !record.permissions || !record.permissions.canTransfer) {
            return;
        }

        this.setState({
            moveRecord: record,
            moveDateTime: this.recordDateTimeLocalValue(record),
            moveRecordError: '',
        });
    }

    closeMoveRecord() {
        if (this.state.movingRecordId) {
            return;
        }

        this.setState({moveRecord: null, moveDateTime: '', moveRecordError: ''});
    }

    refreshVisibleRecords() {
        if (this.state.isArchive) {
            this.changeIsArchive(this.state.activeDate);
            return;
        }

        this.loadFutureRecords();
    }

    moveRecord() {
        const record = this.state.moveRecord;
        const value = String(this.state.moveDateTime || '').trim();
        if (!record || this.state.movingRecordId) {
            return;
        }
        if (!value) {
            this.setState({moveRecordError: 'Укажите новые дату и время.'});
            return;
        }

        this.setState({movingRecordId: record.id, moveRecordError: '', recordActionError: ''});
        api({
            url: GlobalVariable.host() + '/widget/staff/v2/records/' + record.id,
            headers: {'Content-Type': 'application/json'},
            withCredentials: true,
            method: 'PATCH',
            data: {dateTime: value.slice(0, 16).replace('T', ' ') + ':00'},
        }).then(() => {
            this.setState({
                movingRecordId: null,
                moveRecord: null,
                moveDateTime: '',
                moveRecordError: '',
            }, () => this.refreshVisibleRecords());
        }).catch((error) => {
            this.setState({
                movingRecordId: null,
                moveRecordError: this.recordActionErrorMessage(error, 'Не удалось перенести запись.'),
            });
        });
    }

    deleteManagedRecord(record) {
        if (!record || !record.permissions || !record.permissions.canDelete || this.state.deletingRecordId) {
            return;
        }
        if (!window.confirm('Удалить запись? Это действие нельзя отменить.')) {
            return;
        }

        this.setState({deletingRecordId: record.id, recordActionError: ''});
        api({
            url: GlobalVariable.host() + '/widget/staff/v2/records/' + record.id,
            headers: {'Content-Type': 'application/json'},
            withCredentials: true,
            method: 'DELETE',
        }).then(() => {
            this.setState({deletingRecordId: null}, () => this.refreshVisibleRecords());
        }).catch((error) => {
            this.setState({
                deletingRecordId: null,
                recordActionError: this.recordActionErrorMessage(error, 'Не удалось удалить запись.'),
            });
        });
    }

    renderManagedRecordActions(record, includeVisitStatus = false) {
        if (!record || !record.id) {
            return null;
        }

        const permissions = record.permissions || {};
        const deleting = this.state.deletingRecordId === record.id;
        return (
            <div className='d-flex flex-column mt-2 record-management-actions' style={{gap: 6}}>
                {includeVisitStatus ? (
                    <>
                        <button type='button' disabled={Boolean(this.state.statusUpdating)} onClick={() => this.changeRecordStatus(record.id, 'completed')} className='txt-small chio-card p-1'>Выполнена</button>
                        <button type='button' disabled={Boolean(this.state.statusUpdating)} onClick={() => this.changeRecordStatus(record.id, 'no_show')} className='txt-small chio-card p-1'>Не пришёл</button>
                    </>
                ) : null}
                {permissions.canTransfer ? (
                    <button type='button' disabled={Boolean(this.state.movingRecordId)} onClick={() => this.openMoveRecord(record)} className='txt-small chio-card p-1 record-transfer-button'>Перенести</button>
                ) : null}
                {permissions.canDelete ? (
                    <button type='button' disabled={Boolean(this.state.deletingRecordId)} onClick={() => this.deleteManagedRecord(record)} className='txt-small chio-card p-1 record-delete-button'>
                        {deleting ? 'Удаляем...' : 'Удалить'}
                    </button>
                ) : null}
            </div>
        );
    }

    openClientCard(clientId) {
        if (!clientId) {
            return;
        }
        this.setState({clientCardOpen: true, clientCard: null, clientFormula: '', clientCardError: ''});
        api({
            url: GlobalVariable.host() + '/widget/staff/v2/clients/' + clientId + '/card',
            headers: {'Content-Type': 'application/json'},
            withCredentials: true,
            method: 'GET',
        }).then((result) => {
            this.setState({
                clientCard: result.data,
                clientFormula: result.data?.formula?.value || '',
            });
        }).catch(() => {
            this.setState({clientCardError: 'Не удалось открыть карточку клиента'});
        });
    }

    saveClientCard() {
        const clientId = this.state.clientCard?.client?.id;
        if (!clientId || this.state.clientCardSaving) {
            return;
        }
        this.setState({clientCardSaving: true, clientCardError: ''});
        api({
            url: GlobalVariable.host() + '/widget/staff/v2/clients/' + clientId + '/card',
            headers: {'Content-Type': 'application/json'},
            withCredentials: true,
            method: 'PUT',
            data: {formula: this.state.clientFormula},
        }).then((result) => {
            this.setState({
                clientCard: result.data,
                clientFormula: result.data?.formula?.value || '',
                clientCardSaving: false,
            });
        }).catch(() => {
            this.setState({clientCardSaving: false, clientCardError: 'Не удалось сохранить формулу'});
        });
    }

    statusLabel(status) {
        switch (status || 'confirmed') {
            case 'completed':
                return 'Выполнена';
            case 'no_show':
                return 'Не пришёл';
            case 'canceled':
                return 'Отменена';
            case 'confirmed':
            default:
                return 'Подтверждена';
        }
    }

    durationLabel(record) {
        if (record.durationLabel) {
            return record.durationLabel;
        }
        const minutes = Number(record.durationMinutes || record.length || record.seanceLength || 0);
        if (!minutes) {
            return '';
        }
        if (minutes >= 60) {
            const hours = Math.floor(minutes / 60);
            const rest = minutes % 60;
            return rest ? `${hours} ч ${rest} мин` : `${hours} ч`;
        }

        return `${minutes} мин`;
    }

    companyAddress(record) {
        return String(record.companyAddress || record.company || '').trim();
    }

    latestServiceText(latestService) {
        if (!latestService) {
            return '';
        }
        const services = Array.isArray(latestService.services) ? latestService.services.join(', ') : '';
        return [latestService.date, services].filter(Boolean).join(' — ');
    }

    searchClients() {
        const query = String(this.state.clientSearchQuery || '').trim();
        if (query.length < 2) {
            this.setState({
                clientSearchResults: [],
                clientSearchError: 'Введите имя или телефон клиента',
            });
            return;
        }

        this.setState({clientSearchLoading: true, clientSearchError: ''});
        api({
            url: GlobalVariable.host() + '/widget/staff/v2/clients/search',
            headers: {'Content-Type': 'application/json'},
            withCredentials: true,
            method: 'GET',
            params: {q: query},
        }).then((result) => {
            this.setState({
                clientSearchLoading: false,
                clientSearchResults: Array.isArray(result.data?.items) ? result.data.items : [],
            });
        }).catch(() => {
            this.setState({
                clientSearchLoading: false,
                clientSearchError: 'Не удалось найти клиента',
            });
        });
    }

    handleClientSearchKeyDown(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.searchClients();
        }
    }

    renderClientSearch() {
        return (
            <div className='staff-client-search ml-3 mr-3 mb-3'>
                <div className='staff-client-search-title'>Поиск клиента</div>
                <div className='staff-client-search-form'>
                    <input
                        className='form-control staff-client-search-input'
                        type='text'
                        placeholder='Имя или телефон'
                        value={this.state.clientSearchQuery}
                        onChange={(event) => this.setState({clientSearchQuery: event.target.value})}
                        onKeyDown={(event) => this.handleClientSearchKeyDown(event)}
                    />
                    <button
                        type='button'
                        className='staff-client-search-button'
                        disabled={this.state.clientSearchLoading}
                        onClick={() => this.searchClients()}
                    >
                        {this.state.clientSearchLoading ? 'Ищем' : 'Найти'}
                    </button>
                </div>
                {this.state.clientSearchError ? (
                    <div className='staff-client-search-error'>{this.state.clientSearchError}</div>
                ) : null}
                {this.state.clientSearchResults.length ? (
                    <div className='staff-client-search-results'>
                        {this.state.clientSearchResults.map((client) => (
                            <button
                                type='button'
                                key={client.id}
                                className='staff-client-search-result'
                                onClick={() => this.openClientCard(client.id)}
                            >
                                <span>
                                    <strong>{client.name || 'Клиент'}</strong>
                                    {client.phone ? <small>{client.phone}</small> : null}
                                </span>
                                <em>{this.latestServiceText(client.latestService) || 'Карточка клиента'}</em>
                            </button>
                        ))}
                    </div>
                ) : null}
            </div>
        );
    }

    renderClientCard() {
        if (!this.state.clientCardOpen) {
            return null;
        }
        const card = this.state.clientCard;
        return (
            <div className='changePointBlock'>
                <div className='changePoint staff-client-card-modal' style={{maxHeight: '85vh', overflowY: 'auto'}}>
                    <div className='staff-client-card-head'>
                        <div>
                            <div className='txt-large bold'>Карточка клиента</div>
                            <div className='staff-client-card-note'>Данные видит только сотрудник</div>
                        </div>
                        <button
                            type='button'
                            className='staff-client-card-close-icon'
                            onClick={() => this.setState({clientCardOpen: false})}
                        >
                            x
                        </button>
                    </div>
                    {this.state.clientCardError ? (
                        <div className='txt-middle mb-2' style={{color: '#e72f44'}}>{this.state.clientCardError}</div>
                    ) : null}
                    {!card ? (
                        <div className='txt-middle mb-3'>Загрузка...</div>
                    ) : (
                        <>
                            <div className='staff-client-card-person'>
                                <div className='txt-middle bold'>{card.client?.name || 'Клиент'}</div>
                                {card.client?.phone ? (
                                    <div className='txt-middle'>{card.client.phone}</div>
                                ) : null}
                            </div>
                            <div className='staff-client-card-block'>
                                <div className='staff-client-card-label'>Последняя услуга</div>
                                <div className='staff-client-card-value'>
                                    {this.latestServiceText(card.latestService) || 'Пока нет завершённых визитов'}
                                </div>
                            </div>
                            <div className='staff-client-card-label mt-3 mb-2'>Формула красителя</div>
                            <textarea
                                className='staff-client-formula'
                                style={{minHeight: 120}}
                                placeholder='Например: тон 7.3, оксид 3%, корни 35 минут'
                                value={this.state.clientFormula}
                                onChange={(event) => this.setState({clientFormula: event.target.value})}
                            />
                            <button
                                type='button'
                                onClick={() => this.saveClientCard()}
                                className='staff-client-card-save'
                                disabled={this.state.clientCardSaving}
                            >
                                {this.state.clientCardSaving ? 'Сохраняем...' : 'Сохранить'}
                            </button>
                            {(card.logs || []).length ? (
                                <div className='mt-3'>
                                    <div className='txt-middle bold mb-2'>История изменений</div>
                                    {(card.logs || []).map((log, index) => (
                                        <div key={index} className='txt-small mb-2'>
                                            <div>{log.createdAt} {log.staffName}</div>
                                            <div>Было: {log.oldValue || 'пусто'}</div>
                                            <div>Стало: {log.newValue || 'пусто'}</div>
                                        </div>
                                    ))}
                                </div>
                            ) : null}
                        </>
                    )}
                    <button
                        type='button'
                        onClick={() => this.setState({clientCardOpen: false})}
                        className='staff-client-card-close-footer'
                    >
                        Закрыть
                    </button>
                </div>
            </div>
        );
    }

    renderMoveRecordModal() {
        const record = this.state.moveRecord;
        if (!record) {
            return null;
        }

        const saving = this.state.movingRecordId === record.id;
        return (
            <div className='changePointBlock' onClick={() => this.closeMoveRecord()}>
                <div className='changePoint staff-client-card-modal record-move-modal' onClick={(event) => event.stopPropagation()}>
                    <div className='staff-client-card-head'>
                        <div>
                            <div className='txt-large bold'>Перенос записи</div>
                            <div className='staff-client-card-note'>Клиент: {record.client || 'не указан'}</div>
                        </div>
                        <button
                            type='button'
                            className='staff-client-card-close-icon'
                            disabled={saving}
                            onClick={() => this.closeMoveRecord()}
                        >
                            x
                        </button>
                    </div>
                    <label className='record-move-field'>
                        <span>Новые дата и время</span>
                        <input
                            type='datetime-local'
                            value={this.state.moveDateTime}
                            disabled={saving}
                            onChange={(event) => this.setState({moveDateTime: event.target.value, moveRecordError: ''})}
                        />
                    </label>
                    {this.state.moveRecordError ? (
                        <div className='record-action-error'>{this.state.moveRecordError}</div>
                    ) : null}
                    <button
                        type='button'
                        className='staff-client-card-save'
                        disabled={saving || !this.state.moveDateTime}
                        onClick={() => this.moveRecord()}
                    >
                        {saving ? 'Переносим...' : 'Перенести запись'}
                    </button>
                    <button
                        type='button'
                        className='staff-client-card-close-footer'
                        disabled={saving}
                        onClick={() => this.closeMoveRecord()}
                    >
                        Отмена
                    </button>
                </div>
            </div>
        );
    }

    changeIsArchive(date2 = null) {
        this.setState({
            recordsPrevLoaded: false,
            recordsPrevError: '',
            isArchive: true,
        })
        let urlAPI2 = GlobalVariable.host() + '/widget/staff/v1/profile/my-record/prev';
        let result = this.state.activeDate;
        if (date2) {
             result = date2;
        }

        const data2 = {
            'dateTime': result,
            'limit': 100,
        };
        api({
            url: urlAPI2,
            headers: {'Content-Type': 'application/json'},
            method: "post",
            data: data2,
            withCredentials: true,
            // receive two    parameter endpoint url ,form data
        })
            .then(result => { // then print response status

                this.setState({
                    recordsPrev2: Array.isArray(result.data) ? result.data : [],
                    recordsPrevLoaded: true,
                    isArchive: true,
                    isLoad: true
                })
            }).catch(error => {

            this.setState({
                recordsPrev2: [],
                recordsPrevLoaded: true,
                recordsPrevError: 'Не удалось загрузить прошлые записи. Проверьте подключение и попробуйте еще раз.',
                isArchive: true,
                isLoad: true,
            })
        })

    }

    renderNotRecord() {
        if (this.state.recordsNextError) {
            return (
                <div className='w-100 h-100 d-flex align-items-center justify-content-center text-center'>
                    {this.state.recordsNextError}
                </div>
            )
        }
        if (!this.state.recordsNextLoaded) {
            return (
                <div className='w-100 h-100 d-flex align-items-center justify-content-center'>
                    Загружаем записи
                </div>
            )
        }
        if (this.state.recordsNext2.length === 0) {
            return (
                <div className='w-100 h-100 d-flex align-items-center justify-content-center'>
                    Записей не найдено
                </div>
            )
        }
    }
    renderNotRecordPrev() {
        if (this.state.recordsPrevError) {
            return (
                <div className='w-100 h-100 d-flex align-items-center justify-content-center text-center'>
                    {this.state.recordsPrevError}
                </div>
            )
        }
        if (!this.state.recordsPrevLoaded) {
            return (
                <div className='w-100 h-100 d-flex align-items-center justify-content-center'>
                    Загружаем записи
                </div>
            )
        }
        if (this.state.recordsPrev2.length === 0) {

            return (
                <div className='w-100 h-100 d-flex align-items-center justify-content-center'>
                    Записей не найдено
                </div>
            )
        }
    }

    renderCreateRecordButton() {
        return (
            <Link to='/create-record' className='records-create-button'>
                <span>+</span>
                <strong>Создать запись</strong>
            </Link>
        );
    }

    renderRecordListTabs() {
        const availableCount = this.state.availableRecords.length;
        return (
            <div className='record-list-mode-tabs'>
                <button
                    type='button'
                    className={this.state.recordListMode === 'mine' ? 'active' : ''}
                    onClick={() => this.setState({recordListMode: 'mine'})}
                >
                    Мои записи
                </button>
                <button
                    type='button'
                    className={this.state.recordListMode === 'available' ? 'active' : ''}
                    onClick={() => this.setState({recordListMode: 'available'}, () => this.loadAvailableRecords())}
                >
                    Доступные {availableCount > 0 ? `(${availableCount})` : ''}
                </button>
                <Link to='/salon-schedule' className='record-all-masters-link'>Записи всех мастеров</Link>
            </div>
        );
    }

    renderAvailableRecordsPage() {
        return (
            <div className='main my-record'>
                <div className='content mx-w-content'>
                    <PageHeader pageTitle='Записи' backBtnUrl='/'/>
                    <div className='pt-header'></div>
                    {this.renderRecordListTabs()}
                    <div className='available-records-intro'>
                        Записи без выбранного мастера. После подтверждения клиент появится в ваших записях.
                    </div>
                    {this.state.availableRecordsError ? (
                        <div className='available-records-error'>{this.state.availableRecordsError}</div>
                    ) : null}
                    {this.state.availableRecordsLoading ? (
                        <div className='available-records-empty'>Загружаем записи...</div>
                    ) : null}
                    {!this.state.availableRecordsLoading && !this.state.availableRecordsError && this.state.availableRecords.length === 0 ? (
                        <div className='available-records-empty'>Сейчас нет доступных записей.</div>
                    ) : null}
                    <div className='available-records-list'>
                        {this.state.availableRecords.map(item => (
                            <div className='available-record-card' key={item.id}>
                                <div className='available-record-card-head'>
                                    <strong>{item.dateTime ? item.dateTime.replace(' ', ' · ').slice(0, 18) : 'Время не указано'}</strong>
                                    <span>{item.durationMinutes || 30} мин.</span>
                                </div>
                                <div className='available-record-services'>
                                    {(item.services || []).map(service => service.title).join(', ') || 'Услуги не указаны'}
                                </div>
                                <button
                                    type='button'
                                    disabled={Boolean(this.state.claimingRecordId)}
                                    onClick={() => this.claimAvailableRecord(item.id)}
                                >
                                    {this.state.claimingRecordId === item.id ? 'Назначаем...' : 'Забрать запись'}
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
                <Menu></Menu>
            </div>
        );
    }

    render() {
        let services = this.state.services;
        if (!this.state.isLoad) {
            return (
                <Preloader></Preloader>
            )
        } else {
            if (this.state.recordListMode === 'available') {
                return this.renderAvailableRecordsPage();
            }
            if (!this.state.isArchive) {
                return (
                    <div className='main my-record'>
                        <div className='content mx-w-content'>
                            {this.renderClientCard()}
                            {this.renderMoveRecordModal()}
                            <PageHeader
                                pageTitle='Мои записи'
                                backBtnUrl='/'/>
                            <div className='pt-header'></div>
                            {this.renderCreateRecordButton()}
                            {this.renderClientSearch()}
                            {this.renderRecordListTabs()}
                            {/*Будущие или прошлые записи*/}


                            <div className='ml-3 mr-3 d-flex justify-content-between'>
                                <div className='p-3 p-sides chio-mark txt-large w-50 text-center'>
                                    Будущие
                                </div>
                                <div onClick={() => {
                                    this.changeIsArchive()
                                }} className='p-3 txt-large chio-mark-back w-50'>
                                    Прошлые
                                </div>
                            </div>
                            {/*Заголовок*/}
                            <div
                                className='chio-card-subheader ml-3 mr-3 pl-3 pr-3 pt-2 d-flex justify-content-between '>
                                <table className='table'>
                                    <tr>
                                        <td className='text-white txt-middle pt-0 col-2 pl-0 border-top-0'>Дата</td>
                                        <td className='text-white txt-middle pt-0 col-2 border-top-0'>Услуга</td>
                                        <td className='text-white txt-middle pt-0 col-1 pr-0  border-top-0'>Стоимость</td>
                                    </tr>
                                </table>
                            </div>
                            {/*Дата*/}
                            <div
                                className='chio-card-subheader bg-shadow ml-3 mr-3 pl-3 pr-3 pt-2 dark-textc txt-middle'>
                                {this.renderNotRecord()}
                            </div>
                            {this.state.recordActionError ? (
                                <div className='record-action-error ml-3 mr-3 mt-2'>{this.state.recordActionError}</div>
                            ) : null}

                            {(this.state.recordsNext2.length !== 0) &&
                            <div className='chio-card ml-3 mr-3 mb-2 pl-3 pr-3 pt-2 pb-2 bg-white'>

                                <table className='table'>
                                    {this.state.recordsNext2.map((itemRecord) => (
                                        <tr>
                                            <td className='dark-textc txt-middle col-2 pl-0'>
                                                {itemRecord.date} {itemRecord.time}
                                                <div className='txt-small p-0'>{itemRecord.client}</div>
                                                {(itemRecord.clientPhone || itemRecord.phoneClient) ? (
                                                    <div className='txt-small p-0'>{itemRecord.clientPhone || itemRecord.phoneClient}</div>
                                                ) : null}
                                                {this.companyAddress(itemRecord) ? (
                                                    <div className='txt-small mt-1 record-company-address'>
                                                        <span aria-hidden='true'>📍</span> {this.companyAddress(itemRecord)}
                                                    </div>
                                                ) : null}
                                            </td>
                                            <td className='dark-textc txt-small col-2'>
                                                {itemRecord.service}
                                                {this.durationLabel(itemRecord) ? (
                                                    <div className='txt-small mt-1 record-duration'>{this.durationLabel(itemRecord)}</div>
                                                ) : null}
                                                {getRecordComment(itemRecord) ? (
                                                    <div className='record-comment'>
                                                        <span>Комментарий:</span> {getRecordComment(itemRecord)}
                                                    </div>
                                                ) : null}
                                            </td>
                                            <td className='dark-textc txt-middle pr-0 col-1'>
                                                {itemRecord.paid != 0?itemRecord.paid +'р':"Запись"}
                                                {itemRecord.status ? (
                                                    <div className='txt-small mt-1 record-status-label'>{itemRecord.statusLabel || this.statusLabel(itemRecord.status)}</div>
                                                ) : null}
                                                {itemRecord.id ? (
                                                    <>
                                                        {this.renderManagedRecordActions(itemRecord, true)}
                                                        {itemRecord.assignment && itemRecord.assignment.mode === 'any' && itemRecord.assignment.assignmentStatus === 'assigned' && (!itemRecord.status || itemRecord.status === 'confirmed') ? (
                                                            <button
                                                                type='button'
                                                                disabled={this.state.releasingRecordId === itemRecord.id}
                                                                onClick={() => this.releasePoolRecord(itemRecord.id)}
                                                                className='txt-small chio-card p-1 mt-2 pool-record-release'
                                                            >
                                                                {this.state.releasingRecordId === itemRecord.id ? 'Возвращаем...' : 'Вернуть в общий пул'}
                                                            </button>
                                                        ) : null}
                                                    </>
                                                ) : null}
                                                {itemRecord.clientId ? (
                                                    <button type='button' onClick={() => this.openClientCard(itemRecord.clientId)} className='txt-small chio-card p-1 mt-2' style={{border: 'none'}}>Клиент</button>
                                                ) : null}
                                            </td>
                                        </tr>
                                    ))}

                                </table>
                            </div>
                            }


                            {/*<div className='text-center txt-middle bold'>*/}
                            {/*    Показать больше*/}
                            {/*</div>*/}

                            {/*<div className={'list-my-record'}>*/}
                            {/*    <div className={'d-flex mt-3'}>*/}
                            {/*        <div><img style={{marginBottom: '3px'}} className="mr-3"*/}
                            {/*                  src={"/img/Ellipse1.png"}/></div>*/}
                            {/*        <div style={{color: '#0D263F', marginLeft: '10px'}}>Будущая запись</div>*/}
                            {/*    </div>*/}
                            {/*    <div className={'d-flex mt-3 mb-3'}>*/}
                            {/*        <div><img style={{marginBottom: '3px'}} className="mr-3"*/}
                            {/*                  src={"/img/Ellipse2.png"}/></div>*/}
                            {/*        <div style={{color: '#939393', marginLeft: '10px'}}>Прошлая запись</div>*/}
                            {/*    </div>*/}
                            {/*    <table className="table">*/}
                            {/*        <thead>*/}
                            {/*        <tr>*/}
                            {/*            <th scope="col">Дата</th>*/}
                            {/*            <th scope="col">Услуги</th>*/}
                            {/*            <th scope="col">Стоимость</th>*/}

                            {/*        </tr>*/}
                            {/*        </thead>*/}
                            {/*        <tbody>*/}
                            {/*        {*/}
                            {/*            this.state.recordsNext.map((item) => (*/}

                            {/*                this.renderNextRecord(item)*/}
                            {/*            ))*/}
                            {/*        }*/}
                            {/*        {*/}
                            {/*            this.state.recordsPrev.map((item) => (*/}
                            {/*                <tr*/}
                            {/*                    className={'prevRecord'}>*/}
                            {/*                    <th>{item.date} {item.time}</th>*/}
                            {/*                    <td>{item['service'].map((itemService) => (*/}
                            {/*                        <div>{itemService.serviceName}</div>*/}
                            {/*                    ))}</td>*/}
                            {/*                    <td>{item.paid} ₽</td>*/}

                            {/*                </tr>*/}
                            {/*            ))*/}
                            {/*        }*/}

                            {/*        </tbody>*/}
                            {/*    </table>*/}

                            {/*</div>*/}

                            {/*<Link to={'/point'} className={'d-flex'} style={{justifyContent: 'center'}}>*/}
                            {/*    <div className={'btn-active mt-3 mb-3 '}>*/}
                            {/*        Продолжить*/}
                            {/*    </div>*/}
                            {/*</Link>*/}

                        </div>
                        <Menu></Menu>
                    </div>
                )
            } else {
                return (
                    <div className='main my-record'>
                        <div className='content mx-w-content'>
                            {this.renderClientCard()}
                            {this.renderMoveRecordModal()}
                            <PageHeader
                                pageTitle='Мои записи'
                                backBtnUrl='/'/>
                            <div className='pt-header'></div>
                            {this.renderCreateRecordButton()}
                            {this.renderClientSearch()}
                            {/*Будущие или прошлые записи*/}

                            <div className='ml-3 mr-3 d-flex justify-content-between'>
                                <div className='p-3 p-sides chio-mark txt-large w-50 text-center'>
                                    Прошлые
                                </div>
                                <div onClick={() => {
                                    this.setState({ isArchive: false}, () => this.loadFutureRecords());
                                }} className='p-3 txt-large chio-mark-back w-50'>
                                    Будущие
                                </div>
                            </div>
                            {/*Заголовок*/}
                            {this.renderCalendar()}
                            <div
                                className='chio-card-subheader ml-3 mr-3 pl-3 pr-3 pt-2 d-flex justify-content-between ' style={{marginTop:'-20px'}}>
                                <table className='table'>
                                    <tr>
                                        <td className='text-white txt-middle pt-0 col-2 pl-0 border-top-0'>Дата</td>
                                        <td className='text-white txt-middle pt-0 col-2 border-top-0'>Услуга</td>
                                        <td className='text-white txt-middle pt-0 col-1 pr-0  border-top-0'>Стоимость</td>
                                    </tr>
                                </table>
                            </div>

                            <div className='chio-card ml-3 mr-3 mb-2 pl-3 pr-3 pt-2 pb-2 bg-white'>
                                {this.state.recordActionError ? (
                                    <div className='record-action-error mb-2'>{this.state.recordActionError}</div>
                                ) : null}
                                <table className='table'>
                                    {
                                        this.renderNotRecordPrev()
                                    }
                                    {this.state.recordsPrev2.map((itemRecord) => (
                                        <tr>
                                            <td className='dark-textc txt-middle col-2 pl-0'>
                                                {itemRecord.date} {itemRecord.time}
                                                <div className='txt-small p-0'>{itemRecord.client}</div>
                                                {(itemRecord.clientPhone || itemRecord.phoneClient) ? (
                                                    <div className='txt-small p-0'>{itemRecord.clientPhone || itemRecord.phoneClient}</div>
                                                ) : null}
                                                {this.companyAddress(itemRecord) ? (
                                                    <div className='txt-small mt-1 record-company-address'>
                                                        <span aria-hidden='true'>📍</span> {this.companyAddress(itemRecord)}
                                                    </div>
                                                ) : null}
                                            </td>
                                            <td className='dark-textc txt-small col-2'>
                                                {itemRecord.service}
                                                {this.durationLabel(itemRecord) ? (
                                                    <div className='txt-small mt-1 record-duration'>{this.durationLabel(itemRecord)}</div>
                                                ) : null}
                                                {getRecordComment(itemRecord) ? (
                                                    <div className='record-comment'>
                                                        <span>Комментарий:</span> {getRecordComment(itemRecord)}
                                                    </div>
                                                ) : null}
                                            </td>
                                            <td className='dark-textc txt-middle pr-0 col-1'>
                                                {itemRecord.paid != 0?itemRecord.paid +'р':"Запись"}
                                                {itemRecord.status ? (
                                                    <div className='txt-small mt-1 record-status-label'>{itemRecord.statusLabel || this.statusLabel(itemRecord.status)}</div>
                                                ) : null}
                                                {this.renderManagedRecordActions(itemRecord)}

                                            </td>
                                        </tr>
                                    ))}
                                </table>
                            </div>
                            {/*/!*Дата*!/*/}
                            {/*<div*/}
                            {/*    className='chio-card-subheader bg-shadow ml-3 mr-3 pl-3 pr-3 pt-2 dark-textc txt-middle'>*/}
                            {/*    9.09.2024*/}
                            {/*</div>*/}
                            {/*/!*Список услуг в конкретную дату*!/*/}
                            {/*<div className='chio-card ml-3 mr-3 mb-2 pl-3 pr-3 pt-2 pb-2 bg-white'>*/}
                            {/*    <table className='table'>*/}
                            {/*        <tr>*/}
                            {/*            <td className='dark-textc txt-middle col-2 pl-0'>*/}
                            {/*                12:00*/}
                            {/*                <div className='txt-small p-0'>Александра</div>*/}
                            {/*                <div className='txt-small p-0'>ул. Лермонтова 25</div>*/}
                            {/*            </td>*/}
                            {/*            <td className='dark-textc txt-small col-2'>*/}
                            {/*                Имиджевая стрижка*/}
                            {/*            </td>*/}
                            {/*            <td className='dark-textc txt-middle pr-0 col-1'>*/}
                            {/*                3000р*/}
                            {/*            </td>*/}
                            {/*        </tr>*/}
                            {/*        <tr>*/}
                            {/*            <td className='dark-textc txt-middle col-2 pl-0 '>*/}
                            {/*                14:0*/}
                            {/*                <div className='txt-small p-0'>Петя</div>*/}
                            {/*                <div className='txt-small p-0'>ул. Лермонтова 25</div>*/}
                            {/*            </td>*/}
                            {/*            <td className='dark-textc txt-small col-2 '>*/}
                            {/*                Уходовая процедура (30-50см)*/}
                            {/*            </td>*/}
                            {/*            <td className='dark-textc txt-middle pr-0 col-1 '>*/}
                            {/*                5000р*/}
                            {/*            </td>*/}
                            {/*        </tr>*/}
                            {/*    </table>*/}
                            {/*</div>*/}

                            {/*<div className='text-center txt-middle bold'>*/}
                            {/*    Показать больше*/}
                            {/*</div>*/}

                            {/*<div className={'list-my-record'}>*/}
                            {/*    <div className={'d-flex mt-3'}>*/}
                            {/*        <div><img style={{marginBottom: '3px'}} className="mr-3"*/}
                            {/*                  src={"/img/Ellipse1.png"}/></div>*/}
                            {/*        <div style={{color: '#0D263F', marginLeft: '10px'}}>Будущая запись</div>*/}
                            {/*    </div>*/}
                            {/*    <div className={'d-flex mt-3 mb-3'}>*/}
                            {/*        <div><img style={{marginBottom: '3px'}} className="mr-3"*/}
                            {/*                  src={"/img/Ellipse2.png"}/></div>*/}
                            {/*        <div style={{color: '#939393', marginLeft: '10px'}}>Прошлая запись</div>*/}
                            {/*    </div>*/}
                            {/*    <table className="table">*/}
                            {/*        <thead>*/}
                            {/*        <tr>*/}
                            {/*            <th scope="col">Дата</th>*/}
                            {/*            <th scope="col">Услуги</th>*/}
                            {/*            <th scope="col">Стоимость</th>*/}

                            {/*        </tr>*/}
                            {/*        </thead>*/}
                            {/*        <tbody>*/}
                            {/*        {*/}
                            {/*            this.state.recordsNext.map((item) => (*/}

                            {/*                this.renderNextRecord(item)*/}
                            {/*            ))*/}
                            {/*        }*/}
                            {/*        {*/}
                            {/*            this.state.recordsPrev.map((item) => (*/}
                            {/*                <tr*/}
                            {/*                    className={'prevRecord'}>*/}
                            {/*                    <th>{item.date} {item.time}</th>*/}
                            {/*                    <td>{item['service'].map((itemService) => (*/}
                            {/*                        <div>{itemService.serviceName}</div>*/}
                            {/*                    ))}</td>*/}
                            {/*                    <td>{item.paid} ₽</td>*/}

                            {/*                </tr>*/}
                            {/*            ))*/}
                            {/*        }*/}

                            {/*        </tbody>*/}
                            {/*    </table>*/}

                            {/*</div>*/}

                            {/*<Link to={'/point'} className={'d-flex'} style={{justifyContent: 'center'}}>*/}
                            {/*    <div className={'btn-active mt-3 mb-3 '}>*/}
                            {/*        Продолжить*/}
                            {/*    </div>*/}
                            {/*</Link>*/}

                        </div>
                        <Menu></Menu>
                    </div>
                )
            }
        }

    }
}

export default MyRecord;
